import { api } from '../../lib/api';

export const BUDGET_PERIOD_TYPES = [
  { value: 'Monthly', label: 'Monthly' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Annual', label: 'Annual' },
  { value: 'Custom', label: 'Custom' },
];

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const budgetsApi = {
  list: (params = {}) => api.get(`/budgets${toQuery(params)}`),
  availability: (params = {}) => api.get(`/budgets/availability${toQuery(params)}`),
  create: (payload) => api.post('/budgets', payload),
  update: (id, payload) => api.putWithId(`/budgets/${id}`, id, payload),
  remove: (id) => api.del(`/budgets/${id}`),
};
